import React, { useState } from 'react';
import './ChatBot.scss';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Icon */}
      <div className="chatbot-icon" onClick={() => setIsOpen(!isOpen)}>
      🤖
      </div>

      {/* Chat Popup */}
      {isOpen && (
        <div className="chat-popup">
          <div className="chat-header">
            <span>🤖 Chatbot Assistant</span>
            <button onClick={() => setIsOpen(false)}>✖</button>
          </div>
          <div className="chat-body">
            <p>Hi there! How can I help you today?</p>
            {/* Replace with chat functionality later */}
          </div>
          <div className="chat-footer">
            <input type="text" placeholder="Type your message..." />
            <button>Send</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBot;
